export default __webpack_public_path__ + "default-train.png?884160d01d952bb8a8a48132f8009957";